var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationWrong(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationWrong") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 11,
    cy: 11,
    r: 11
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-500.000000, -829.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Failed-message",
    transform: "translate(485.000000, 810.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotificationWrong",
    transform: "translate(15.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F94A4A",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7396687,11 L15.6360772,13.8964085 C16.118152,14.3784833 16.122862,15.155371 15.6391165,15.6391165 C15.1587203,16.1195128 14.3824206,16.1220893 13.8964085,15.6360772 L11,12.7396687 L8.10359147,15.6360772 C7.62151667,16.118152 6.84462897,16.122862 6.36088349,15.6391165 C5.88048724,15.1587203 5.87791072,14.3824206 6.36392278,13.8964085 L9.26033131,11 L6.36392278,8.10359147 C5.88184798,7.62151667 5.87713801,6.84462897 6.36088349,6.36088349 C6.84127973,5.88048724 7.61757942,5.87791072 8.10359147,6.36392278 L11,9.26033131 L13.8964085,6.36392278 C14.3784833,5.88184798 15.155371,5.87713801 15.6391165,6.36088349 C16.1195128,6.84127973 16.1220893,7.61757942 15.6360772,8.10359147 L12.7396687,11 Z",
    id: "Combined-Shape-Copy-4",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationWrong);
export default __webpack_public_path__ + "static/media/icNotificationWrong.cff9f56ca4fbd665e5374c948c3c990b.svg";
export { ForwardRef as ReactComponent };